var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrid2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.752,
    height: 29.31,
    viewBox: "0 0 27.752 29.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "grid-1x2_1_",
    "data-name": "grid-1x2 (1)",
    d: "M10.032,1.769H1.672V26.541h8.36Zm15.048,0H16.72v8.847h8.36Zm0,15.924v8.847H16.72V17.694ZM0,1.769A1.723,1.723,0,0,1,1.672,0h8.36A1.723,1.723,0,0,1,11.7,1.769V26.541a1.723,1.723,0,0,1-1.672,1.769H1.672A1.723,1.723,0,0,1,0,26.541Zm15.048,0A1.723,1.723,0,0,1,16.72,0h8.36a1.723,1.723,0,0,1,1.672,1.769v8.847a1.723,1.723,0,0,1-1.672,1.769H16.72a1.723,1.723,0,0,1-1.672-1.769ZM16.72,15.924a1.723,1.723,0,0,0-1.672,1.769v8.847A1.723,1.723,0,0,0,16.72,28.31h8.36a1.723,1.723,0,0,0,1.672-1.769V17.694a1.723,1.723,0,0,0-1.672-1.769Z",
    transform: "translate(0.5 0.5)",
    fill: "#003082",
    stroke: "#003082",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid2);
export default __webpack_public_path__ + "static/media/grid2.ace95006d7cd429b5db4e80bd807df3d.svg";
export { ForwardRef as ReactComponent };